module.exports = __webpack_public_path__ + "static/media/left-hive.a733398a.svg";